import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import individualServices from '../../Services/individualServices'
import * as Yup from 'yup';
import { useFormik } from 'formik';
export function IndividualDetails() {

    const history = useHistory()
    const data = history.location.state
    const [loader, setLoader] = useState(false)
    const [countryList, setCountryList] = useState([])
    const [detailOpen, setIsDetailOpen] = useState('')
    const [originCountryValue, setOriginCountryValue] = useState('')
    const [destinationCountryValue, setDestinationCountryValue] = useState('')
    let param = new URLSearchParams(history.location.search)


    useEffect(() => {
        onDetail()
    }, [])

    const onDetail = () => {
        let postData = {
            id: param.get('id')
        }
        individualServices.get_individual_details(postData).then(res => {
            setIsDetailOpen(res.data)
            console.log(res.data , 'res')
        })
    }

    return (
        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 border-end">
                                            {/* <h5 className="secHeading">Sender Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1"> name - </td>
                                                        <td className="py-1"> {detailOpen.user_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Contact Person - </td>
                                                        <td className="py-1">Demo Commercialr</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Contact No. - </td>
                                                        <td className="py-1">{detailOpen.user_phone_number}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Email - </td>
                                                        <td className="py-1">{detailOpen.user_email}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-lg-6 col-md-6 border-end">
                                            {/* <h5 className="secHeading">Receiver Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1"> Registered Address- </td>
                                                        <td className="py-1">{detailOpen.address}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Taxation Details - </td>
                                                        <td className="py-1">{detailOpen.taxation_details}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Total Discount - </td>
                                                        <td className="py-1">{detailOpen.total_discount}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </div>

    )
}

